export default __webpack_public_path__ + "static/media/RemolqueDoble VIP5.470db1f6.png";